module.exports = __webpack_public_path__ + "img/hover_icon_perfil_maestro.06768c24.svg";